import { Component, OnInit, Input, NgZone } from '@angular/core';
import { ListComponent } from '../../../shared/list/list.component';
import { BeaconService } from '../beacon.service';
import { ListService } from '../../../shared/list-service.service';
import { AG_GRID_LOCALE_EN } from '../../../shared/list/locale/en.locale';
import { ActionsCellRenderer } from '../../../shared/list/renderer/actions-cell.renderer';
import { DecimalPipe } from '@angular/common';
import { AuthService } from 'src/app/auth-module/auth.service';

@Component({
  selector: 'app-beacon-list',
  templateUrl: './beacon-list.component.html',
  styleUrls: ['./beacon-list.component.css'],
  providers: [ListService, DecimalPipe]
})
export class BeaconListComponent extends ListComponent implements OnInit {

  private gridApi;
  public gridOptions: any;
  public gridLocale;
  @Input() visible: boolean;

  constructor(
    private zone: NgZone,
    public service: BeaconService,
    public listService: ListService,
    public auth: AuthService) {
    super(service, listService);
    this.setObject('beacon');
  }

  ngOnInit() {
    if(this.auth.currentUserValue.user.role == 'Merchant'){
			this.service.merchantId = this.auth.currentUserValue.user.merchant.id;
		}else{
			this.service.merchantId = this.route.firstChild.snapshot.paramMap.get('idMerchant');
		}
    this.gridLocale = AG_GRID_LOCALE_EN;
    this.gridOptions = {
      columnDefs: [
        { headerName: '#', field: 'id', sortable: true, width: 60 },
        { headerName: 'beacon.form.name', field: 'name', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
        { headerName: 'beacon.form.model', field: 'model', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
        { headerName: 'beacon.form.serial', field: 'serial_number', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
        { headerName: 'beacon.form.ble_mac', field: 'ble_mac', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
        {
          headerName: 'beacon.form.status',
          field: 'status',
          sortable: true,
          cellRenderer: params => {
            if (params.value) {
              return this.translate.instant('beacon.active');
            } else {
              return this.translate.instant('beacon.inactive');
            }
          },
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'list.actions',
          field: 'id',
          cellRenderer: 'actionsCellRenderer',
          cellRendererParams: {
            actions: [
              {
                icon: 'ver_active2x.png',
                action: (id) => {
                  this.zone.run(() => {
                    this.show(id);
                  });
                }
              },
              {
                icon: 'icon_editar2x.png',
                action: (id) => {
                  this.zone.run(() => {
                    this.edit(id);
                  });
                }
              },
              {
                icon: 'icon_borrar2x.png',
                action: (id) => {
                  this.delete(id);
                }
              }
            ]
          },
                headerValueGetter: this.localizeHeader.bind(this)
        }
      ],
      frameworkComponents: {
        'actionsCellRenderer': ActionsCellRenderer
      }
    };

    this.loadData();
  }

  show(id){
    this.router.navigate(['/'+this.object + '/'+this.service.merchantId +'/view/'+id]);
  }

  edit(id){
    this.router.navigate(['/'+this.object + '/'+this.service.merchantId +'/edit/'+id]);
  }

  onFilterTextBoxChanged(value): void {
    this.gridApi.setQuickFilter(value);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.refreshHeader();
    if(this.visible)
      this.sizeColumns();
  }

  sizeColumns(){
		this.gridApi.sizeColumnsToFit();
		window.onresize = () => {
			this.gridApi.sizeColumnsToFit();
		}
	}

}
